import Api from "./Api";

class UserApi extends Api {
  static login(email, password, opts={}) {
    return this.post("user/sign_in", { ...opts, suppressErrors: true, user: { email: email, password: password } } ).then(res => {
      window.user.setToken(res.headers.authorization);
      return res;
    });
  }

  static register(values, opts={}) {
    return this.post("user/sign_up", { ...opts, suppressErrors: true, user: values } ).then(res => {
      window.user.setToken(res.headers.authorization);
      return res;
    });
  }

  static requestPassword(email, opts={}) {
    return this.post("user/password", { ...opts, suppressErrors: true, user: { email: email } } ).then(res => {
      return res;
    });
  }

  static updatePassword(newPass, token, opts={}) {
    return this.patch("user/password", { ...opts, suppressErrors: true, user: { password: newPass, reset_password_token: token } } ).then(res => {
      return res;
    });
  }

  static logout() {
    return this.delete("user/logout");
  }

  static omniauth(provider, params={}) {
    return this.get("user/omniauth/" + provider, params);
  }

  static voteData(object, params={}) {
    params.tags = object.tags.map(t => t.slug).join(",");

    return this.get("user/vote-data/" + object.type + "/" + object.slug, params);
  }

  static favorites(opts={}) {
    return this.get("user/favorites", opts);
  }

  static subscriptions(opts={}) {
    return this.get("user/subscriptions", opts);
  }
}

export default UserApi